import { HttpInstance } from "lib/HttpLib";

export const getViewInfo = (param) => {
  return HttpInstance.get(process.env.REACT_APP_USER_SERVER + "/change/postpone_view", {
    params: {
      member_id: param.member_id === null ? "" : param.member_id,
      membership_id: param.member_id === null ? "" : param.membership_id,
      branch_id: param.member_id === null ? "" : param.branch_id,
    },
  });
};

const get_api = {
  getViewInfo,
};

export default get_api;
